module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ITS_contents"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("4QJosh"), _c('span', {
    staticClass: "sup_roman"
  }, [_vm._v("a")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("First Joshua Scroll")]), _vm._v(" (Dead Sea Scrolls)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("4QSam"), _c('span', {
    staticClass: "sup_roman"
  }, [_vm._v("a")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("First Samuel Scroll")]), _vm._v(" (Dead Sea Scrolls)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AB – Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AcT")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Acta Theologica ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ANE – ancient Near East")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ant.")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish Antiquities")]), _vm._v(" (Josephus)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AOTC – Apollos Old Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BBR – Bulletin for Biblical Research ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblica")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BibInt – Biblical Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BibSac – Bibliotheca sacra")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BRev – Bible Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BST – The Bible Speaks Today")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BZ – Biblische Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CBC – Cambridge Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ – Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CJT – Concordia Journal of Theology ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("esvuk")]), _vm._v(" – English Standard Version: Anglicized")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("et")]), _vm._v(" – English Translation")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("GKC – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(", ed. E. Kautzsch, rev. and tr. A. E. Cowley, Oxford: Clarendon, 1910")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HBT – Horizons in Biblical Theology ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Hebr. – Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("hi. – hiphil")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ICC – International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Int – Interpretation ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ITC – International Theological Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Biblical Literature ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of the Evangelical Theological Society")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JPT – Journal of Pentecostal Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSOT")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Study of the Old Testament ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("mss")]), _vm._v(" – manuscripts"), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("mt")]), _vm._v(" – Masoretic Text")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NAC – New American Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NCBC – New Century Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NICOT – New International Commentary on the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NIDOTTE")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(", ed. Willem A. VanGemeren, 5 vols., Grand Rapids: Zondervan, 1997")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("niv")]), _vm._v(" – New International Version")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("nrsva")]), _vm._v(" – New Revised Standard Version: Anglicized")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OT – Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("OTE – Old Testament Essays")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OTL – Old Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("OTS – Oudtestamentische Studiën ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("PNTC – Pillar New Testament Commentary"), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RB – Revue biblique ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RevExp – Review and Expositor")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SEÅ")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Svensk Exegetisk Årsbok")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SJOT – Scandinavian Journal of the Old Testament ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("STR")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Southeastern Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TOTC – Tyndale Old Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TynB – Tyndale Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("VT – Vetus Testamentum ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WBC – Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WO – B. K. Waltke and M. O’Connor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Introduction to Biblical Hebrew Syntax")]), _vm._v(", Winona Lake: Eisenbrauns, 1990")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("yiq. – yiqtol")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZAW – Zeitschrift für Alttestamentliche Wissenschaft ")])]), _vm._v(" "), _c('p', {
    staticClass: "fo"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2402f08e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ITS_abbrev.vue
// module id = 75
// module chunks = 0